<template>
  <div class="relative rounded-xs">
    <div
      class="pointer-events-none absolute top-[48%] -translate-y-1/2 left-0 flex items-center pl-2"
    >
      <MagnifyingGlassIcon class="h-4 w-4 text-gray-500" aria-hidden="true" />
    </div>
    <input
      type="text"
      name="search"
      id="search"
      class="bg-gray-100 block rounded-xs border-transparent pl-8 focus:border-brand-900 focus:ring-brand-900 sm:text-xs placeholder:text-gray-500"
      :placeholder="t('components.buttons.search')"
      v-debounce:500ms="handleSearch"
      :value="modelValue"
    />
  </div>
</template>

<script setup>
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";

defineProps({
  modelValue: {
    type: String,
    required: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const { t } = useI18n();

const handleSearch = (value) => {
  emit("update:modelValue", value);
};
</script>
